<div class="text-container">
    <ui-svg-icon
        class="warning-icon"
        icon="warning"></ui-svg-icon>
    @if (infoText) {
        <div class="text-box">
            <p class="text">{{ infoText }}</p>
            <p class="text row-two">This action affects all versions and can not be undone.</p>
        </div>
    }
</div>
<ui-checkbox
    label="I understand the risk and want to proceed"
    [(selected)]="verified"></ui-checkbox>
<ui-dialog-buttons ui-theme="default">
    <ui-button
        class="buttons"
        text="Cancel"
        (click)="cancel()">
    </ui-button>
    @if (buttonText) {
        <ui-button
            type="primary"
            text="{{ buttonText }}"
            [disabled]="!verified"
            (click)="deleteDeactivateSize()">
        </ui-button>
    }
</ui-dialog-buttons>
